module.exports = __webpack_public_path__ + "static/img/guarantee-gray-seal.png";